import React from 'react';
export function Footer() {
  const scrollToGuarantee = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('guarantee')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="bg-[#050b20] text-slate-400 py-12 px-4 border-t border-white/5 text-center" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <div className="flex justify-center mb-6" data-id="element-139">
          <img src="https://cdn.magicpatterns.com/uploads/qhp7toLt7rU3AhQY846nSK/WhatsApp_Image_2026-06-24_at_6.42.03_PM.jpg" alt="SaberClick" className="w-20 h-20 rounded-full shadow-lg object-cover" data-id="element-140" />
        </div>

        <h3 className="text-xl font-bold text-white mb-2" data-id="element-141">SaberClick</h3>
        <p className="text-sm mb-8" data-id="element-142">
          El conocimiento que tu emprendimiento necesita para crecer en redes.
        </p>

        <div className="flex flex-wrap justify-center gap-6 mb-10 text-sm" data-id="element-143">
          <a href="https://www.instagram.com/saber.click/" target="_blank" rel="noopener noreferrer" className="hover:text-sky transition-colors" data-id="element-144">
            Instagram
          </a>
          <a href="mailto:soportesaberclick@gmail.com" className="hover:text-sky transition-colors" data-id="element-145">
            Contacto
          </a>
          <a href="#guarantee" onClick={scrollToGuarantee} className="hover:text-sky transition-colors" data-id="element-146">
            Garantía y devoluciones
          </a>
        </div>

        <p className="text-xs text-slate-500" data-id="element-147">
          © SaberClick 2025 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}